import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import Network from "./Network";
import ConnectionRequests from "./ConnectionRequests";
import GrowYourContacts from "./GrowYourContacts";
import HexagonalGallery from "./HexagonalGallery";
import MyContactsLocation from "./MyContactsLocation";
import References from "./References";
import { IMAGEAPI } from "../../BackendConnections";
import {
  fetchMyContactsImagesAction,
  fetchMyContactsLocationMapAction,
} from "../../redux/actions/network/networkAction";
import ReactTooltip from "react-tooltip";

export const Connections = (props) => {
  // console.log(props.myContacts);
  const [content, setContent] = useState("");
  const [data, setData] = useState({
    is_myContacts: false,
    is_location: false,
  });
  const [isConnectionAccepted, setIsConnnectionAccepted] = useState(false);
  const [images, setImages] = useState([]);
  // console.log(images);
  // let imagesWithId = props.myContacts

   const connectionAccepted = () => {
    setIsConnnectionAccepted(!isConnectionAccepted);
   };

  useEffect(() => {
    if (Object.keys(props.profile).length > 0) {
      props.fetchMyLocation(props?.profile?.id);

       // Checking if myContacts data is available
      if (props.myContacts.length === 0 && data.is_myContacts === false) {
        setData((prevState) => ({ ...prevState, is_myContacts: true }));
        props.fetchMyContactsImages(props.profile.id);
      }

      if (props.myContacts.length > 0) {
        const result = Object.keys(props.myContacts).map(
          (image) => IMAGEAPI + props.myContacts[image]["profile_pic"]
        );
        setImages(result);
        // console.log(result);
      }
      if (props.myContacts.length > 0) {
        const result = Object.keys(props.myContacts).map((index) => {
          const id = props.myContacts[index]["id"];
          const images = IMAGEAPI + props.myContacts[index]["profile_pic"];
          return { id, images };
        });
        setImages(result);
      }

      //     if (props.locationMap.length === 0 && data.is_location === false) {
      //         setData((prevState) => ({ ...prevState, is_location: true }));
      //         props.fetchMyLocation(props.profile.id)
      //     }
    }
  }, [props,isConnectionAccepted]);
  return (
    <Network>
      {/* Displaying a hexagonal gallery with myContacts images */}
      <HexagonalGallery images={images} />
        {/* Displaying a component for growing contacts */}
      <GrowYourContacts />
       {/* Displaying a component for connection requests */}
      <ConnectionRequests connectionAccepted={connectionAccepted}/>
       {/* Displaying a map of myContacts locations */}
      <MyContactsLocation
        markers={props.locationMap}
        setTooltipContent={setContent}
      />
      {/* {props.locationMap.length > 0 && (
                <ReactTooltip>{content}</ReactTooltip>
            )} */}
       {/* Displaying a component for references */}     
      <References />
    </Network>
  );
};
// Mapping state to props for accessing data from the Redux store
const mapStateToProps = (state) => {
  const user = state.user.user;
  const profile = state.user.profile;
  const myContacts = state.network.myContacts;
  const locationMap = state.network.locationMap;
  return {
    user: user,
    profile: profile,
    myContacts: myContacts,
    locationMap: locationMap,
  };
};
// Mapping dispatch functions to props for triggering Redux actions
const mapDispatchToProps = (dispatch) => {
  return {
    fetchMyContactsImages: (userId) =>
      dispatch(fetchMyContactsImagesAction(userId)),
    fetchMyLocation: (profileId) =>
      dispatch(fetchMyContactsLocationMapAction(profileId)),
  };
};
// Connecting the component to the Redux store
export default connect(mapStateToProps, mapDispatchToProps)(Connections);
